import '../../../../App.css';
import SystemTypesList from "./SystemTypesList";
import SystemTypesAdd from "./SystemTypesAdd";


const SystemTypes = () => {
    return (
        <div className="SystemTypes">
            <h1>System Types</h1>
            <SystemTypesAdd />
            <SystemTypesList/>
        </div>
    );
};
export default SystemTypes;
